<template>
  <footer>
    <div class="nav">
      <router-link to="/change/changeInformation"><button class="footBtn">Замена</button></router-link>
      <router-link to="/montage/copperPipe"><button class="footBtn">Монтаж</button></router-link>
      <router-link to="/repair/repairBoiler"><button class="footBtn">Ремонт</button></router-link>
      <router-link to="/control"><button class="footBtn">диагностирование</button></router-link>
      <router-link to="/service/serviceInformation"><button class="footBtn">Сервис</button></router-link>
      <router-link to="/protection"><button class="footBtn">Защита (СО)</button></router-link>
      <router-link to="/documents"><button class="footBtn">Документы</button></router-link>
      <router-link to="/questions"><button class="footBtn">F.A.Q.</button></router-link>
    </div>
    <div class="contacts">
      <p class="location">ООО "ОБЛГАЗСЕРВИС-СЕВЕР" <br> ул.Горшина, 9, к.1, Химки, Московская область., 141407</p>
      <p class="phone">
        <span>
          <a href="tel:89035498889"><img src="../img/phone.webp" alt="">  WhatsApp</a>
        </span>
        <a href="tel:89035498889">8-903-549-88-89</a>
      </p>
      <p class="phone">
        <span>
          <a href="tel:84957452209"><img src="../img/phone.webp" alt="">  Офис</a>
        </span>
        <a href="tel:84957452209">8-495-745-22-09</a>
      </p>
      <p class="email">
        <span>
          <a href="mailto:7452209@mail.ru"><img src="../img/email.webp" alt=""></a>
        </span>
        <a href="mailto:7452209@mail.ru">7452209@mail.ru</a>
      </p>
    </div>
  </footer>
</template>

<script>
  export default {

  }
</script>

<style scoped>

p {
  text-align: center;
}

p span {
  display: block;
}

p a {
  color: white;
  font-weight: normal;
}

.contacts, .nav {
  width: 90vw;
  display: flex;
  margin-left: 5%;
  margin-right: 5%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.footBtn {
  background: #24305e;
  border: none;
  font-weight: 600;
  color: white;
  padding: 15px;
  font-size: 1em;
  cursor: pointer;
}

.footBtn:hover {
  text-decoration: underline  orange;
}

  footer {
    font-size: 1.2em;
    color: white;
    display: flex;
    flex-direction: column;
    text-align: center;
    height: auto;
    background-color: #24305e;
  }

  .phone, .email {
    font-size: 1.5em;
  }

  span {
    margin: 15px;
  }

  .phone img {
    height: 32px;
    width: 32px;
  }

  .email img {
    height: 32px;
    width: 48px;
  }

  @media (max-width: 1400px) {

    footer {
      flex-direction: row;
    }

    .contacts, .nav {
      flex-direction: column;
    }

    .location {
      font-size: 1.5em;
    }

    .phone, .email {
      font-size: 2em;
    }
  }

@media (max-width: 1000px) {
  .phone, .email {
    font-size: 1.5em;
  }
}

  @media (max-width: 800px) {

    a {
      width: 100%;
      text-align: left;
    }

    .footBtn {
      font-size: 0.8em;
      margin: 0;
      text-align: left;
    }

    .location {
      font-size: 1.2em;
    }

    .phone, .email {
      font-size: 1.5em;
    }

  }

@media (max-width: 500px) {
  a {
    font-size: 20px;
  }
  .location {
    font-size: 0.8em;
  }

  .phone, .email {
    font-size: 0.8em;
  }
}

</style>